import React from "react";
import errorImg from "../../../images/ExamNotTaken.png";
import type { SVGProps } from "react";

export function FluentMdl2Error(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={75}
      height={75}
      viewBox="0 0 2048 2048"
      {...props}
    >
      <path
        fill="currentColor"
        d="M960 0q133 0 255 34t230 96t194 150t150 195t97 229t34 256q0 133-34 255t-96 230t-150 194t-195 150t-229 97t-256 34q-133 0-255-34t-230-96t-194-150t-150-195t-97-229T0 960q0-133 34-255t96-230t150-194t195-150t229-97T960 0m0 1792q114 0 220-30t199-84t169-130t130-168t84-199t30-221t-30-220t-84-199t-130-169t-168-130t-199-84t-221-30q-115 0-221 30t-198 84t-169 130t-130 168t-84 199t-30 221q0 114 30 220t84 199t130 169t168 130t199 84t221 30M896 512h128v640H896zm0 768h128v128H896z"
      ></path>
    </svg>
  );
}
const ExamNotTaken = ({ onClose }: { onClose?: () => void }) => {
  return (
    <div className="max-w-full  max-md:mx-8 md:max-w-[685px] mx-auto mt-10 p-6 bg-white rounded-xl shadow-lg text-center">
      <div className="flex flex-col gap-2">
        <div className="text-[#FF0000] text-center flex flex-col items-center justify-center">
          <FluentMdl2Error />
        </div>

        <h2 className="text-3xl font-bold text-black">Exam Not Taken Yet!</h2>
        <img
          src={errorImg}
          alt="Exam Not Taken"
          className="w-52 mx-auto mb-6"
        />
        <p className="text-gray-700 text-base leading-relaxed">
          It looks like you haven't participated in the College Mentor
          Scholarship.
          <br />
          Contact us at <strong>89595 91818</strong> /{" "}
          <strong>91764 07555</strong>
          <br />
          regarding any queries of exam result
        </p>
      </div>
      <button
        onClick={() => onClose?.()}
        className="mt-6 text-[#FF0000] font-semibold hover:underline"
      >
        Close
      </button>
    </div>
  );
};

export default ExamNotTaken;
